import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnonymousSearchComponent } from './components/anonymous-search/anonymous-search.component';
import { CompletePersonellDataComponent } from './components/complete-personell-data/complete-personell-data.component';
import { EnaioDocumentsDefinitionComponent } from './components/enaio-documents-definition/enaio-documents-definition.component';
import { EnaioDocumentsMainComponent } from './components/enaio-documents-main/enaio-documents-main.component';
import { Config } from '../app-template/models/config.model';
import { EnaioDocumentsConfig } from './enaio-documents.config';

const routes: Routes = [
    {
        path: 'home',
        component: EnaioDocumentsMainComponent,
        canActivate: [() => !Config.get().getModuleConfig(EnaioDocumentsConfig).onlyEmbedded]
    },
    {
        path: 'definition/:defId',
        redirectTo: 'definition/:defId/0',
        pathMatch: 'full'
    },
    {
        path: 'definition/:defId/:parentId',
        component: EnaioDocumentsDefinitionComponent,
        canActivate: [() => !Config.get().getModuleConfig(EnaioDocumentsConfig).onlyEmbedded]
    },
    {
        path: 'as/:defId',
        component: AnonymousSearchComponent,
        canActivate: [() => !Config.get().getModuleConfig(EnaioDocumentsConfig).onlyEmbedded]
    },
    {
        path: 'as/:defId/:searchString',
        component: AnonymousSearchComponent,
        canActivate: [() => !Config.get().getModuleConfig(EnaioDocumentsConfig).onlyEmbedded]
    },
    {
        path: 'definition/as/:defId/:anonymousGuid',
        component: EnaioDocumentsDefinitionComponent,
        canActivate: [() => !Config.get().getModuleConfig(EnaioDocumentsConfig).onlyEmbedded]
    },
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    //Für Demo
    {
        path: 'personell/complete_data/:id',
        component: CompletePersonellDataComponent
    },
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EnaioDocumentsRoutingModule {
}
